var React = require('react');

function Left (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M27.7051 19.62L23.1251 24.2L27.7051 28.79L26.2951 30.2L20.2951 24.2L26.2951 18.2L27.7051 19.62Z","fill":"#423D33","key":0}),React.createElement("rect",{"x":"0.5","y":"0.699951","width":"47","height":"47","rx":"23.5","stroke":"#423D33","key":1})]);
}

Left.defaultProps = {"width":"48","height":"49","viewBox":"0 0 48 49","fill":"none"};

module.exports = Left;

Left.default = Left;
